import React from 'react';
import styles from './styles.module.scss';
import logo from './logo.svg';

const Logo: React.FC = () => {
  return (
    <div className={styles['logo']}>
      <img src={logo} alt="" className={styles['img']} />
    </div>
  );
};

export default Logo;
